module.exports = __webpack_public_path__ + "static/media/Arimo-Bold.a6063823.ttf";